import { render, staticRenderFns } from "./permisos.vue?vue&type=template&id=57a62f2a"
import script from "./permisos.vue?vue&type=script&lang=js"
export * from "./permisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports